import React from 'react';
import { FileSpreadsheet, FileText } from 'lucide-react';
import { tipoAllegato } from '../../utils/circolariEtichette';

type Allegato = Parameters<typeof tipoAllegato>[0];

const COLORI = {
  pdf: 'text-red-600 dark:text-red-400',
  word: 'text-blue-600 dark:text-blue-400',
  excel: 'text-emerald-600 dark:text-emerald-400',
} as const;

/** Icona colorata per tipo di allegato (PDF, Word, Excel), uguale in admin e area riservata. */
export const IconaAllegato: React.FC<{ allegato: Allegato; className?: string }> = ({ allegato, className = 'w-4 h-4' }) => {
  const { tipo } = tipoAllegato(allegato);
  const Icona = tipo === 'excel' ? FileSpreadsheet : FileText;
  return <Icona className={`${className} flex-none ${COLORI[tipo]}`} aria-hidden="true" />;
};

/** Targhetta «PDF» / «Word» / «Excel» accanto al nome del file. */
export const TargaTipoAllegato: React.FC<{ allegato: Allegato }> = ({ allegato }) => (
  <span className="inline-flex px-1.5 py-0.5 text-2xs font-semibold rounded bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 flex-none">
    {tipoAllegato(allegato).etichetta}
  </span>
);
